/**
 * @file action
 */

 import * as Api from './api';
// login
export async function getLogin({state, commit}, params) {
    const data = await Api.getLoginUrl(params);
    commit("SET_USER_INFO", {token: data.data || ''});
    return data;
}
// 用户信息
export async function getUserInfo({ state, commit }, params) {
    const data = await Api.getUserInfo(params);
    commit("SET_USER_INFO", {userName: data.data || ''});
    return data;
}
// logout
export async function logout({ state, commit }, params) {
    return await Api.logoutUrl(params);
}
